// extracted by mini-css-extract-plugin
export default {"ViewContent":"styles_ViewContent__c-87y","row":"styles_row__87lnk","col":"styles_col__E-gNu","mediaContainer":"styles_mediaContainer__L5r40","media":"styles_media__kapqZ"};